export class MessagesResponse {
  id: string;
  is_read: string;
  email: string;
  name: string;
  message: string;
  date: string;

  constructor(
    id: string,
    is_read: string,
    email: string,
    name: string,
    message: string,
    date: string
  ) {
    this.id = id;
    this.is_read = is_read;
    this.email = email;
    this.name = name;
    this.message = message;
    this.date = date;
  }
}
